import React, {Dispatch, SetStateAction} from "react"
import {ErrorMessage, useFormikContext} from "formik"
import classNames from "classnames"
import {faQuestionCircle} from "@fortawesome/free-regular-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import ReactTooltip from "react-tooltip"
import {flattenObject} from "../../utilities/helpers"

interface Props {
	name: string
	label: string
	countryCodeName: string
	phoneNumberName: string
	countryCodeValue: string
	phoneNumberValue: string
	countryCodeOnChange: Dispatch<SetStateAction<any>>
	phoneNumberOnChange: Dispatch<SetStateAction<any>>
	countryCodeOnBlur: Dispatch<SetStateAction<any>>
	phoneNumberOnBlur: Dispatch<SetStateAction<any>>
	showInfoTooltip?: boolean
	infoTooltipText?: string
	fieldClassName?: string
	placeholderCountryCode?: string
	placeholderPhoneNumber?: string
}

export default function PhoneNumber({
	name,
	label,
	countryCodeName,
	phoneNumberName,
	countryCodeValue,
	phoneNumberValue,
	countryCodeOnChange,
	phoneNumberOnChange,
	countryCodeOnBlur,
	phoneNumberOnBlur,
	showInfoTooltip = false,
	infoTooltipText,
	fieldClassName,
	placeholderCountryCode = "+1",
	placeholderPhoneNumber = "1234567890",
}: Props) {
	const {touched, errors} = useFormikContext()
	const hasError = flattenObject(touched).hasOwnProperty(name) && flattenObject(errors).hasOwnProperty(name)
	const className = classNames("phone-number", "textfield", fieldClassName, hasError && "error")

	return (
		<div className={className}>
			<label>
				<span className={classNames("label-text")}>
					{label} {showInfoTooltip ? <FontAwesomeIcon data-tip={infoTooltipText} icon={faQuestionCircle} /> : null}
				</span>
			</label>
			<div className="field-body">
				<p className="control-3 plus-button-wrapper">
					<a className="button is-static plus-button">+</a>
				</p>
				<div className="control-3 country-code-prefix">
					<input
						name={countryCodeName}
						placeholder={placeholderCountryCode}
						type="text"
						value={countryCodeValue}
						required={!!phoneNumberValue}
						onChange={(e) => countryCodeOnChange(e.target.value)}
						onBlur={countryCodeOnBlur}
					/>
				</div>
				<div className="control-3 w-100 phone-number-suffix">
					<input
						name={phoneNumberName}
						placeholder={placeholderPhoneNumber}
						type="text"
						value={phoneNumberValue}
						required={!!countryCodeValue}
						onChange={(e) => phoneNumberOnChange(e.target.value)}
						onBlur={phoneNumberOnBlur}
					/>
				</div>
			</div>
			<ErrorMessage name={countryCodeName} component="div" className="form-error" />
			<ErrorMessage name={phoneNumberName} component="div" className="form-error" />
			<ReactTooltip effect={"solid"} className={"tooltip"} />
		</div>
	)
}
